import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const ReporterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
`;

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Subtitle = styled.div`
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleHeading
      : textStyleCss(theme.atlas.typography.semantic.body)};
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  margin-bottom: 8px;
`;

export const ErrorContainer = styled.div<{ color?: string }>`
  ${(props) => props.theme.newTypography.textStyleBodySmall};
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.color === 'red'
        ? props.theme.newPalette.red.R300
        : props.theme.newPalette.neutral.N600
      : props.theme.atlas.semantic.color.type.muted};
  margin-top: 4px;
`;

export const AnonymousContainer = styled.div`
  display: flex;
`;

export const SwitchLabel = styled.span`
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBodySmall
      : textStyleCss(theme.atlas.typography.semantic.caption)};
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  margin-left: 8px;
`;
